import {Component, OnDestroy, OnInit} from '@angular/core';
import {GetSetDataService} from '../../services/get-set-data.service';
import {FaqStandaloneComponent} from '../faq-standalone/faq-standalone.component';

@Component({
  selector: 'app-faq-view',
  templateUrl: './faq-view.component.html',
  imports: [
    FaqStandaloneComponent
  ],
  styleUrls: ['./faq-view.component.scss']
})
export class FaqViewComponent implements OnInit, OnDestroy {

  static classRemoveBigBar: string = 'helper-remove-big-search';

  constructor(private getSet: GetSetDataService) {
  }

  ngOnInit() {
    // Hides the big/maroon/red component.
    document.getElementsByTagName('body')[0].classList.add(FaqViewComponent.classRemoveBigBar);
    this.getSet.scrollToTop();
  }

  ngOnDestroy() {
    document.getElementsByTagName('body')[0].classList.remove(FaqViewComponent.classRemoveBigBar);
  }
}
